// Grymwyrd — polski. Gaslit gothic horror o wiecznym zmroku.
// Transkrypcja interfejsu edytora scen, arkusza bohatera, inicjatywy, rzutów kostką i komunikacji stołu.

export const demoPl = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Graj teraz — wejdź do Grymwyrd',
  'demo.seoDescription':
    'Obrót świata, miejsce przy stole, stworzenie bohatera Grymwyrd i rzut kostką — przewodnia wycieczka po wirtualnym stole Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Świat Grymwyrd',
  'demo.globe.spinningWorld': 'Świat się obraca…',
  'demo.globe.tagline': 'Żywy świat horrorów fantasy',
  'demo.globe.arrivedHeading': 'Region Greywick',
  'demo.globe.heading': 'Znajdź swoje miejsce w wiecznym zmroku',
  'demo.globe.subheading': 'Stół czeka w sercu świata. Zajmij miejsce i stwórz bohatera.',
  'demo.globe.enterCta': 'Zstąp do Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Stań się częścią historii',
  'demo.account.subheading':
    'Stwórz darmowe konto, aby odblokować pełną encyklopedię Grymwyrd i zapisać bohatera, którego stworzysz — lub przejdź jako gość i odkrywaj teraz.',
  'demo.account.createAccount': 'Stwórz konto',
  'demo.account.logIn': 'Zaloguj się',
  'demo.account.continueAsGuest': 'Kontynuuj jako gość',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Inicjatywa',
  'demo.create.lobbyEyebrow': 'Grymwyrd Virtual Tabletop · Poczekalnia',
  'demo.create.heading': 'Stwórz swego bohatera',
  'demo.create.subheading': 'Postać SRD 5.2.1, urodzona z Grymwyrd. Nadaj imię, wybierz powołanie i rzuć kostkami.',
  'demo.create.nameLabel': 'Imię',
  'demo.create.namePlaceholder': 'Kim się staną?',
  'demo.create.chooseCalling': 'Wybierz powołanie',
  'demo.create.keyAbility': 'Główna: {ability}',
  'demo.create.abilityScores': 'Zdolności',
  'demo.create.abilityScoresHint': '— kliknij, aby rzucić 3d6',
  'demo.create.rollAbilityAria': 'Rzuć {ability} (3d6)',
  'demo.create.keepStandard': 'Albo zachowaj standardowe 10 i wskoczysz w akcję.',
  'demo.create.initiativeResult': 'Inicjatywa {initiative} — kostki się toczą, stół patrzy na ciebie…',
  'demo.create.bonesTumble': 'Kostki się toczą…',
  'demo.create.rollInitiativeCta': 'Rzuć inicjatywę i zajmij miejsce',
  'demo.create.chooseCallingHint': 'Wybierz powołanie, aby zajać miejsce.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'Stół nie mógł być przygotowany',
  'demo.table.errorBody': 'Wirtualny stół jest teraz niedostępny.',
  'demo.table.browseLiveTables': 'Przeglądaj dostępne stoły',
  'demo.table.settingTable': 'Przygotowywanie stołu…',
  'demo.table.connecting': 'Łączenie ze stołem…',
  'demo.table.heroTable': 'Stół {name}',
  'demo.table.firstTable': 'Twój pierwszy stół',
  'demo.table.diceTrayHeading': 'Tacka na kostki',
  'demo.table.initiativeHeading': 'Inicjatywa',
  'demo.table.initiativePrompt': 'Rzuć kostkami, aby ustalić kolejność walki.',
  'demo.table.rollForInitiative': 'Rzuć inicjatywę',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Wstrzymaj grę anonimowo',
  'demo.table.xcard': 'X-karta',
  'demo.table.saveHeroTitle': 'Stwórz darmowe konto, aby zapisać bohatera',
  'demo.table.saveHero': 'Zapisz bohatera',
  'demo.table.statusLive': 'Na żywo',
  'demo.table.statusConnecting': 'Łączenie',
  'demo.table.actionLogHeading': 'Dziennik akcji',
  'demo.table.recentRollsHeading': 'Ostatnie rzuty',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Karta bohatera',
  'demo.panel.companion': 'Towarzysz',
  'demo.panel.diceTray': 'Tacka na kostki',
  'demo.panel.macros': 'Makra',
  'demo.panel.diceConsole': 'Konsola kostki',
  'demo.panel.initiative': 'Inicjatywa',
  'demo.panel.poll': 'Głosowanie',
  'demo.panel.recentRolls': 'Ostatnie rzuty',
  'demo.panel.reference': 'Podręcznik',
  'demo.panel.chat': 'Czat',
  'demo.panel.handouts': 'Materiały',
  'demo.panel.safety': 'Bezpieczeństwo',
  'demo.panel.sceneAndCues': 'Scena i wskazówki',
  'demo.panel.replay': 'Powtórka',
  'demo.panel.recap': 'Streszczenie',
  'demo.panel.actionLog': 'Dziennik akcji',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Walka wręcz',
  'demo.action.cast': 'Rzuć czar',
  'demo.action.move': 'Ruch',
  'demo.action.block': 'Blok',
  'demo.action.chooseTarget': 'Wybierz cel dla {action}…',
  'demo.action.controlling': 'Kontrolujesz:',
  'demo.action.cannotAct': '{label} nie może działać — wybierz drużynę, gracza, pojazd lub NPC.',
  'demo.action.selectActionable': 'Wybierz coś, co można uaktywnić, aby na tym działać.',
  'demo.action.cancel': 'Anuluj',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Ustalanie kolejności…',
  'demo.tracker.combatant': 'Walczący {n}',
  'demo.tracker.previousTurn': 'Poprzednia tura',
  'demo.tracker.round': 'Runda {round}',
  'demo.tracker.endCombatTitle': 'Zakończ walkę',
  'demo.tracker.end': 'Koniec',
  'demo.tracker.nextTurnTitle': 'Następna tura',
  'demo.tracker.next': 'Następna',
  'demo.tracker.hitPoints': 'Punkty życia',
  'demo.tracker.reduceHp': 'Zmniejsz PŻ {name}',
  'demo.tracker.raiseHp': 'Zwiększ PŻ {name}',
  'demo.tracker.addStatusEffect': 'Dodaj efekt statusu',
  'demo.tracker.removeFromOrder': 'Usuń z kolejności',
  'demo.tracker.removeFromOrderTitle': 'Usuń z kolejności',
  'demo.tracker.removeCondition': 'Usuń {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'Stół jest wstrzymany',
  'demo.xcard.heading': 'Stół jest wstrzymany',
  'demo.xcard.body':
    'Ktoś podniesił X-kartę. Wstrzymujemy grę bez pytań i bez nazwisk. Gdy wszyscy będą gotowi, kontynuujcie.',
  'demo.xcard.resume': 'Jesteśmy gotowi — wznów',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Materiały',
  'demo.handouts.titlePlaceholder': 'Tytuł (opcjonalnie)',
  'demo.handouts.bodyPlaceholder': 'Notatka, wskazówka, tekst do czytania…',
  'demo.handouts.push': 'Wyślij do stołu',
  'demo.handouts.whispered': 'Szeptem',
  'demo.handouts.dismiss': 'Odrzuć materiał',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Bezpieczeństwo',
  'demo.safety.description': 'Granice, których nie przekroczymy; przesłony, które zaciągamy. Wspólne dla całego stołu, nigdy nienazwane.',
  'demo.safety.linesLabel': 'Granice (stanowcze nie)',
  'demo.safety.veilsLabel': 'Przesłony (zaciemnienie)',
  'demo.safety.removeItem': 'Usuń „{item}"',
  'demo.safety.addLinePlaceholder': 'Dodaj granicę…',
  'demo.safety.addVeilPlaceholder': 'Dodaj przesłonę…',
  'demo.safety.addLine': 'Dodaj granicę',
  'demo.safety.addVeil': 'Dodaj przesłonę',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Karta bohatera',
  'demo.sheet.hp': 'PŻ',
  'demo.sheet.ac': 'KO',
  'demo.sheet.classLevel': '{className} · Poz 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Urządzenie towarzysza',
  'demo.companion.description':
    'Sparuj telefon lub tablet jako drugi ekran tylko do odczytu — inicjatywa, ostatnie rzuty i scena duplikują się na urządzeniu. Możesz odwołać w każdej chwili.',
  'demo.companion.pairDevice': 'Sparuj urządzenie',
  'demo.companion.qrAriaLabel': 'Kod QR sparowania towarzysza',
  'demo.companion.copied': 'Skopiowano',
  'demo.companion.copyLink': 'Skopiuj link',
  'demo.companion.revoke': 'Odwołaj',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Makra kostki',
  'demo.macros.dismissError': 'Odrzuć błąd',
  'demo.macros.newMacro': 'Nowe makro',
  'demo.macros.namePlaceholder': 'Nazwa (bez punktów)',
  'demo.macros.labelPlaceholder': 'Etykieta przycisku (opcjonalnie)',
  'demo.macros.save': 'Zapisz makro',
  'demo.macros.noDots': 'Nazwy makr nie mogą zawierać punktów.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Głosowanie',
  'demo.poll.questionPlaceholder': 'Zapytaj stół…',
  'demo.poll.optionPlaceholder': 'Opcja {n}',
  'demo.poll.removeOption': 'Usuń opcję {n}',
  'demo.poll.addOption': 'Dodaj opcję',
  'demo.poll.openPoll': 'Otwórz głosowanie',
  'demo.poll.live': 'Na żywo',
  'demo.poll.closed': 'Głosowanie zamknięte',
  'demo.poll.vote': 'Głosuj',
  'demo.poll.closePoll': 'Zamknij głosowanie',
  'demo.poll.startNewPoll': 'Rozpocznij nowe głosowanie',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Streszczenie sesji',
  'demo.recap.tagline': 'Historia twojego stołu, gdy pył się osiedzi.',
  'demo.recap.gathering': 'Zbieranie historii…',
  'demo.recap.getRecap': 'Pobierz streszczenie sesji',
  'demo.recap.notableRolls': 'Znaczące rzuty',
  'demo.recap.copied': 'Skopiowano!',
  'demo.recap.share': 'Udostępnij',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Podręcznik',
  'demo.reference.searchPlaceholder': 'Wyszukaj potwora, zaklęcie, zasadę…',
  'demo.reference.searchAria': 'Przeszukaj encyklopedię, aby udostępnić',
  'demo.reference.typeToSearch': 'Wpisz co najmniej dwie litery, aby przeszukać żywą encyklopedię.',
  'demo.reference.searching': 'Szukanie…',
  'demo.reference.open': 'Otwórz {title}',
  'demo.reference.share': 'Udostępnij',
  'demo.reference.dismiss': 'Odrzuć podręcznik',
  'demo.reference.backToSearch': 'Wróć do wyszukiwania',
  'demo.reference.loadingContent': 'Ładowanie treści…',
  'demo.reference.notOwned':
    'Nie posiadasz jeszcze tej książki. Pełny podręcznik odblokowuje się, gdy dodasz ją do biblioteki.',
  'demo.reference.contentDown': 'Treść jest teraz niedostępna. Spróbuj za chwilę.',
  'demo.reference.noAdditionalContent': 'Brak dodatkowej treści dla tego podręcznika.',
  'demo.reference.noLinkedContent': 'Brak powiązanej treści książki dla tego podręcznika.',
  'demo.reference.shareToTable': 'Udostępnij stołowi',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Powtórka',
  'demo.replay.tagline': 'Przejdź wstecz przez sesję moment po momencie.',
  'demo.replay.loading': 'Ładowanie…',
  'demo.replay.loadReplay': 'Załaduj powtórkę',
  'demo.replay.loadMore': 'Załaduj więcej',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Kostki',
  'demo.dice.dismissError': 'Odrzuć błąd',
  'demo.dice.labelPlaceholder': 'Atak (opcjonalnie)',
  'demo.dice.roll': 'Rzuć',
  'demo.dice.rolledForReal': 'Rzuciłem naprawdę',
  'demo.dice.totalPlaceholder': 'Razem (wymagane)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (opcjonalnie)',
  'demo.dice.physLabelPlaceholder': 'Etykieta (opcjonalnie)',
  'demo.dice.logPhysical': 'Zaloguj rzut fizyczny',
  'demo.dice.onTable': '🎲 na-stole',
  'demo.dice.private': 'Prywatnie',
  'demo.dice.public': 'Publicznie',
  'demo.dice.rolledPrivately': 'rzucono prywatnie',
  'demo.dice.exploded': 'wybuchło',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Scena i wskazówki',
  'demo.scene.current': 'Scena: {scene}',
  'demo.scene.cueSuffix': '— wskazówka: {cue}',
  'demo.scene.noScene': 'Brak sceny',
  'demo.scene.oneShotCues': 'Wskazówki jednorazowe',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} na {x},{y}',
  'demo.map.tile': 'Pole {x},{y}',
  'demo.map.fogged': 'Zakryte mgłą',
  'demo.map.battleMap': 'Mapa walki',
  'demo.map.gm': 'MG',
  'demo.map.noMap': 'Brak mapy',
  'demo.map.uploadedMap': 'Przesłana mapa',
  'demo.map.uploadTitle': 'Przeslij obraz mapy jako tło kanwy',
  'demo.map.reading': 'Odczyt…',
  'demo.map.upload': 'Prześlij',
  'demo.map.size': 'Rozmiar',
  'demo.map.shrinkMap': 'Zmniejsz mapę',
  'demo.map.growMap': 'Powiększ mapę',
  'demo.map.widthShort': 'S',
  'demo.map.narrowMap': 'Wąż mapę',
  'demo.map.widenMap': 'Poszerz mapę',
  'demo.map.heightShort': 'W',
  'demo.map.shortenMap': 'Skróć mapę',
  'demo.map.heightenMap': 'Wydłuż mapę',
  'demo.map.fitTitle': 'Zresetuj pozycję i rozciągnij, aby wypełnić siatkę',
  'demo.map.fit': 'Dopasuj',
  'demo.map.lock': 'Zablokuj',
  'demo.map.adjust': 'Dostosuj',
  'demo.map.fogOn': 'Mgła WŁ — kliknij, aby wyłączyć',
  'demo.map.fogOff': 'Mgła WYŁ — kliknij, aby włączyć',
  'demo.map.fog': 'Mgła',
  'demo.map.exitPaintTitle': 'Wyjdź z trybu rysowania',
  'demo.map.paintTitle': 'Maluj mgłę — kliknij lub przeciągnij pola, aby odkryć/ukryć',
  'demo.map.exitPaint': 'Wyjdź z rysowania',
  'demo.map.paint': 'Maluj',
  'demo.map.hexGridTitle': 'Siatka heksagonalna — kliknij na kwadratową',
  'demo.map.squareGridTitle': 'Siatka kwadratowa — kliknij na heksagonalną',
  'demo.map.hex': 'Heks',
  'demo.map.zoomOut': 'Oddal',
  'demo.map.zoomLevel': 'Poziom przybliżenia',
  'demo.map.zoomIn': 'Przybliż',
  'demo.map.resetView': 'Zresetuj widok',
  'demo.map.reset': 'Reset',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Rozwiń {title}',
  'demo.dock.collapse': 'Zwiń {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Opuścić stół?',
  'demo.leave.heading': 'Opuścić stół?',
  'demo.leave.body':
    'Jesteś w środku gry. To stół gościa — jeśli teraz wyjdziesz, sesja się skończy i twój bohater będzie zagubiony.',
  'demo.leave.stay': 'Zostań przy stole',
  'demo.leave.leaveAnyway': 'Wyjdź i tak',
}
